import Edit from "./Edit.js";
import List from "./List.js";
import Show from "./Show.js";
import Create from "./Create.js";
import BlockPreview from "./BlockPreview.js";

export default { List, Show, Edit, Create, BlockPreview };
